import React, { useState } from 'react';

function App() {
    const [inputFile, setInputFile] = useState('');
    const [outputFile, setOutputFile] = useState('output.mp4'); // Default output file name
    const [customArgs, setCustomArgs] = useState(''); // For custom arguments
    const [downloadLink, setDownloadLink] = useState(null); // Link for downloading the file
    const [isLoading, setIsLoading] = useState(false);

    const handleFileChange = (e) => {
        setInputFile(e.target.files[0]); // Get the selected file object
    };

    const handleArgsChange = (e) => {
        setCustomArgs(e.target.value); // Update custom arguments from dropdown
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!inputFile || !customArgs) {
            alert('Please provide both input file and custom arguments!');
            return;
        }

        setIsLoading(true);
        setDownloadLink(null); // Clear previous download link

        const formData = new FormData();
        formData.append('inputFile', inputFile); // Append the selected file
        formData.append('outputFile', outputFile);
        formData.append('args', customArgs);

        try {
            const response = await fetch('http://162.243.169.66:5000/process', {
                method: 'POST',
                body: formData, // Sending form data with the file
            });

            const data = await response.json();

            if (data.status === 'success') {
                // Set the download link to the returned file path
                setDownloadLink(data.output_file);
                alert('File processed successfully! Click the download link below.');
            } else {
                alert("fartybutt")
            }
        } catch (error) {
            console.error('Error:', error);
            alert('Something went wrong! Check the console for details.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
            <h1>FFMPEG Custom Processor</h1>
            <form onSubmit={handleSubmit} style={{ maxWidth: '400px', margin: '0 auto' }}>
                <label>
                    Input File:
                    <input
                        type="file"
                        onChange={handleFileChange}
                        style={{
                            width: '100%',
                            margin: '10px 0',
                            padding: '10px',
                        }}
                    />
                </label>

                <label>
                    Output File Name:
                    <input
                        type="text"
                        value={outputFile}
                        onChange={(e) => setOutputFile(e.target.value)}
                        placeholder="Enter desired output file name"
                        style={{
                            width: '100%',
                            margin: '10px 0',
                            padding: '10px',
                        }}
                    />
                </label>

                <label>
                    Custom FFmpeg Arguments:
                    <select
                        value={customArgs}
                        onChange={handleArgsChange}
                        style={{
                            width: '100%',
                            margin: '10px 0',
                            padding: '10px',
                        }}
                    >
                        <option value="">Select a custom option</option>
                        <option value="youtubeshort">YouTube Shorts</option>
                        <option value="makegif">Discord GIF (Non-Nitro)</option>
                        <option value="./ffmpeg -i input.mp4 -vf scale=1280:720">Custom Scaling (1280x720)</option>
                        <option value="./ffmpeg -i input.mp4 -c:v libx264 -preset fast">Fast H.264 Encoding</option>
                        <option value="./ffmpeg -i input.mp4 -c:a aac">AAC Audio Encoding</option>
                    </select>
                </label>

                <button
                    type="submit"
                    style={{
                        padding: '10px 20px',
                        backgroundColor: '#007BFF',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                    }}
                    disabled={isLoading}
                >
                    {isLoading ? 'Processing...' : 'Submit'}
                </button>
            </form>

            {downloadLink && (
                <div style={{ marginTop: '20px' }}>
                    <h3>Download Processed File:</h3>
                    <a
                        href={`http://162.243.169.66:5000/uploads/${downloadLink}`} // Backend should serve this file
                        download={outputFile} // Trigger download with custom name
                        style={{
                            display: 'inline-block',
                            marginTop: '10px',
                            padding: '10px 20px',
                            backgroundColor: '#28a745',
                            color: '#fff',
                            textDecoration: 'none',
                            borderRadius: '4px',
                        }}
                    >
                        Download
                    </a>
                </div>
            )}
        </div>
    );
}

export default App;
